import React from "react";

export default function SubscriptionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      className="subscription-icon"
    >
      <path
        d="M3.53846 0V16.8077C3.53846 17.2987 3.14481 17.6923 2.65385 17.6923C2.16288 17.6923 1.76923 17.2987 1.76923 16.8077V6.19231H2.65385V4.42308H0V16.8077C0 18.2629 1.19865 19.4615 2.65385 19.4615H11.5C11.3231 18.9308 11.2231 18.3115 11.2231 17.6923H5.14315C5.244 17.4128 5.30858 17.12 5.30858 16.8077V1.76923H19.4624V11.5C20.0817 11.6769 20.7009 11.9423 21.2317 12.3846V0H3.53846ZM7.07692 3.53846V7.07692H17.6923V3.53846H7.07692ZM7.07692 8.84615V10.6154H11.5V8.84615H7.07692ZM13.2692 8.84615V10.6154H17.6923V8.84615H13.2692ZM7.07692 11.5V13.2692H11.5V11.5H7.07692ZM17.6923 12.3846C14.7518 12.3846 12.3846 14.7518 12.3846 17.6923C12.3846 20.6328 14.7518 23 17.6923 23V21.2308C15.6789 21.2308 14.1538 19.7057 14.1538 17.6923C14.1538 15.6789 15.6789 14.1538 17.6923 14.1538C19.7057 14.1538 21.2308 15.6789 21.2308 17.6923C21.2308 18.4602 21.0123 19.1696 20.6222 19.7384L19.4615 18.5769L19.0192 22.5577L23 22.1154L21.8942 21.0096C22.6293 20.0861 23 18.9104 23 17.6923C23 14.7518 20.6328 12.3846 17.6923 12.3846ZM7.07692 14.1538V15.9231H11.5V14.1538H7.07692Z"
        strokeWidth="0"
        fill="currentColor"
      />
    </svg>
  );
}
